import { SmevMonitoringChartTypesEnum } from '../enums/SmevMonitoringChartTypesEnum';

export const smevMonitoringChartsTypeWithName: Record<SmevMonitoringChartTypesEnum, string> = {
  [SmevMonitoringChartTypesEnum.FAILED_BY_SMEV_MESSAGES]: 'Ошибки от СМЭВ',
  [SmevMonitoringChartTypesEnum.FAILED_MESSAGES]: 'Ошибки',
  [SmevMonitoringChartTypesEnum.SUCCESSFUL_MESSAGES]: 'Успешно выполнены',
};
